<template>
  <div>
    <div v-scroll="onScrollSearch">
        <div>
            <vue-headful :title="$t('title_articles')" description="title" />
        </div>
        <v-container fluid>
            <v-row class="ma-0">
                <TopBar />
            </v-row>

            <book-carousel-pop-up
                :titleCarousel="$t('library.title_carousel_1')"
                :booksList="favoriteBookList"
                v-show="!showSearch"
            />
            <book-carousel-pop-up
                :titleCarousel="$t('library.title_carousel_5')"
                :booksList="boughtBookList"
                v-show="!showSearch"
                class="mt-6"
            />
        </v-container>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import * as Sentry from '@sentry/vue'
import { loadScript } from "vue-plugin-load-script";
import _ from 'lodash';
import TopBar from '@/components/home/TopBar.vue'
import BookCarouselPopUpVue from '@/components/library/BookCarouselPopUp.vue'
import bookService from '../../services/book'
let Airtable = null;

import VueSlickCarousel from 'vue-slick-carousel'
import 'vue-slick-carousel/dist/vue-slick-carousel.css'

import AnalyticEventsMixin from "../../mixins/analyticEvents"
import { AnalyticEventTypes } from '@/constants/AnalyticEventTypes'

export default {
    mixins: [AnalyticEventsMixin],
    data() {
        return {
            modalActive: false,
            active: true,
            favoriteBookListUser: {
                code: 0,
                data: [],
            },
            boughtBookListUser: {
                code: 0,
                data: [],
            },
            loading: false,
            last: false,
            empty: false,
            settings: {
                infinite: false,
                arrows: false,
                variableWidth: true,
                speed: 500,
                rows: 1,
                slidesToShow: 4,
                slidesToScroll: 4,
                initialSlide: 0,
            },
            dialog: false,
            currentPage: 1,
            totalPages: 0,
            modalFlipbook: false,
            showSearch: false,
        }
    },
    created() {
        this.getFavoriteBooksList()
        this.getBoughtBooksList()
    },
    mounted() {
        if (_.endsWith(this.user.school.rbd, "restricted")) {
            this.fixedLibrary = true
            this.loadFixedLibrary(this.user.school.id)
        }
        this.createAnalyticEvent(AnalyticEventTypes.GoToLibrary)
    },
    computed: {
        ...mapState({
            user_loaded: (state) => state.userData.user_loaded,
            user_id: (state) => state.userData.user.id,
            user: (state) => state.userData.user,
        }),
        favoriteBookList() {
            return this.favoriteBookListUser
        },
        boughtBookList() {
            return this.boughtBookListUser
        },
        tittleRule() {
            return [() => !!this.search || this.$t('library.book_tittle_required')]
        },
    },
    components: {
        TopBar,
        'book-carousel-pop-up': BookCarouselPopUpVue,
        VueSlickCarousel,
    },
    methods: {
        onScrollSearch() {
            console.log('scroll')
        },
        getFavoriteBooksList() {
            bookService
                .getBookListFavoriteByUser(this.user_id)
                .then((response) => {
                    if (response.content.length > 0) {
                        this.favoriteBookListUser = {
                            code: 1,
                            data: response.content.slice(0, 10),
                        }
                    } else {
                        this.favoriteBookListUser = {
                            code: 2,
                            data: response.content,
                        }
                    }
                })
                .catch((error) => {
                    Sentry.captureException(error)
                    this.favoriteBookListUser = {
                        code: 3,
                        error,
                    }
                })
        },
        getBoughtBooksList() {
            bookService
                .getAllPayBooksByUser(this.user_id, this.payPage, this.paySize)
                .then((response) => {
                    if (response.content && response.content.content.length > 0) {
                        this.boughtBookListUser = {
                            code: 1,
                            data: response.content.content.slice(0, 10),
                        }
                    } else {
                        this.boughtBookListUser = {
                            code: 2,
                            data: [],
                        }
                    }
                })
                .catch((error) => {
                    Sentry.captureException(error)
                    this.boughtBookListUser = {
                        code: 3,
                        error,
                    }
                })
        },
        loadAirtable() {
            loadScript("https://s3.us-east-2.amazonaws.com/beereaders.com/lib/airtable.browser.js")
            .then(() => {
                // Script is loaded, do something
                Airtable = window.require('airtable')
                this.loadFixedLibrary()
            })
            .catch(() => {
                // Failed to fetch script
                console.log('Unable to load Airtable')
            });
        },
        loadFixedLibrary() {
            const vm = this;
            if (Airtable) {
                const base = new Airtable({apiKey: 'keyed4Q3x3VmpjUMK'}).base('app4LuUIH9qFukCVo');
                base('Books').select({
                    // Selecting the first 3 records in Grid view:
                    // maxRecords: 50,
                    view: "Grid view"
                }).eachPage(function page(records, fetchNextPage) {
                    // This function (`page`) will get called for each page of records.
                    records.forEach((record) => {
                        try {
                            if (_.includes(record.get('BeeReaders ID (from Schools)'), vm.user.school.id.toString())) {
                                vm.fixedLibraryBooks.push({
                                    id: record.get('id'),
                                    title: record.get('title'),
                                    resourceDir: record.get('resourceDir'),
                                    bookAbstract: record.get('bookAbstract'),
                                    fromAge: record.get('fromAge'),
                                    toAge: record.get('toAge')
                                })
                            }
                        } catch (error) {
                            console.log(error)
                        }
                    });

                    // To fetch the next page of records, call `fetchNextPage`.
                    // If there are more records, `page` will get called again.
                    // If there are no more records, `done` will get called.
                    try {
                        fetchNextPage();
                    } catch(er) {
                        console.log(er)
                    }

                }, function done(err) {
                    if (err) console.error(err)
                    _.forEach(_.groupBy(vm.fixedLibraryBooks, 'fromAge'), (group, ageGroup) => {
                        vm.fixedLibrarySections.push(
                            {
                                name: `Edad recomendada ${ageGroup}+`,
                                books: {
                                    code: 1,
                                    data: _.take(group, 10)
                                }
                            }
                        )
                    })
                });
            } else {
                this.loadAirtable()
            }
        },
    },
}
</script>
<style lang="scss" scoped>

</style>